import React, { useContext } from 'react'
import GlobalContext from '../GlobalContext'
import CustTable from '../../Common/CustTable'
import dayjs from 'dayjs'
import { chatColumns } from './chatColumns'

export default function OpenChatsTab () {
  const { openChats, boxes } = useContext(GlobalContext)

  return (
    <CustTable
      style={{ height: 'calc(100vh - 350px)' }}
      height={700}
      initColumns={chatColumns(boxes)}
      dataSource={openChats.filter(chat => chat.open).sort((a, b) => dayjs(b.last_message.created_at).diff(dayjs(a.last_message.created_at)))}
      key={'id'}
    />
  )
}
